import apiProvider from './utilities/provider'

const url = 'applications'

const apiApplications = {
  applyForPosition: (token, data) => apiProvider.post(`${url}/${token}`, data),
}

export default apiApplications
